import React, { FC, useCallback, useMemo } from 'react';
import { Select, SelectProps } from 'antd';
import { NoContentItem } from '../common/components';
import { useConfidentialDataObjectsQuery } from './query/useConfidentialDataObjectsQuery';
import type { ConfidentialDataObjectType } from './schema';
import type { DataObjectGroupType, DataObjectType } from './types';
import { formatCodeName } from '../common/utils';

export interface ConfidentialDataObjectFormSelectProps
  extends Omit<SelectProps<string | string[]>, 'id'> {
  confidentialDataObjects?: ConfidentialDataObjectType[];
}

export const ConfidentialDataObjectFormSelect: FC<
  ConfidentialDataObjectFormSelectProps
> = (props) => {
  const { confidentialDataObjects, dropdownStyle, ...rest } = props;
  const { data } = useConfidentialDataObjectsQuery({
    initialData: confidentialDataObjects,
    enabled: !confidentialDataObjects,
  });

  const options = useMemo(
    () =>
      (data || []).map((confidentialDataObject) => ({
        label: formatCodeName(confidentialDataObject),
        value: getConfidentialDataObjectValue(confidentialDataObject),
      })),
    [data]
  );

  const filterOption = useCallback(
    (input: string, option?: { label: string }) => {
      return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    },
    []
  );

  return (
    <Select<any, any>
      {...rest}
      id="confidential-dataObject"
      showSearch
      options={options}
      filterOption={filterOption}
      notFoundContent={<NoContentItem />}
      styles={{
        popup: { root: { width: 'max-content', ...dropdownStyle } },
      }}
    />
  );
};

export const getConfidentialDataObjectValue = ({
  type,
  id,
}: ConfidentialDataObjectType):
  | `${DataObjectGroupType}-${number}`
  | `${DataObjectType}-${number}` => `${type}-${id}`;
